import React from "react";
import { TreePine, Heart, Award, Shield, Palette, Users, Sun, Utensils } from "lucide-react";
import { childcareData } from "../../data/mock";

const Features = () => {
  const iconMap = {
    "TreePine": TreePine,
    "Heart": Heart,
    "Award": Award,
    "Shield": Shield
  };

  const additionalFeatures = [
    {
      icon: Palette,
      title: "Creative Arts & Crafts",
      description: "Daily creative activities to develop imagination and fine motor skills",
      color: "blue"
    },
    {
      icon: Users,
      title: "Small Group Setting",
      description: "Intimate groups ensuring personalized attention for every child",
      color: "pink"
    },
    {
      icon: Sun,
      title: "Outdoor Learning",
      description: "Nature-based education with animals and extensive garden exploration",
      color: "blue"
    },
    {
      icon: Utensils,
      title: "Healthy Nutrition",
      description: "Fresh, nutritious meals and snacks included in daily care",
      color: "pink"
    }
  ];

  return (
    <section id="features" className="py-20 bg-gradient-to-b from-blue-50/50 to-pink-50/50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-slate-800 mb-6">
            Why Choose 
            <span className="text-transparent bg-gradient-to-r from-blue-400 to-pink-400 bg-clip-text"> Heathbourne House?</span>
          </h2>
          <p className="text-xl text-slate-600 max-w-3xl mx-auto">
            {childcareData.about.description}
          </p>
        </div>

        {/* Main Features Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-16">
          {childcareData.about.features.map((feature, index) => {
            const IconComponent = iconMap[feature.icon];
            return (
              <div 
                key={index}
                className="group bg-white/80 backdrop-blur-sm p-8 rounded-2xl border border-pink-100 hover:border-blue-200 transition-all duration-300 hover:shadow-xl hover:-translate-y-1"
              >
                <div className="flex items-center justify-center w-16 h-16 bg-slate-100 rounded-2xl mb-6 group-hover:scale-110 transition-transform">
                  <IconComponent className="h-8 w-8 text-slate-600" />
                </div>
                <h3 className="text-xl font-bold text-slate-800 mb-3">
                  {feature.title}
                </h3>
                <p className="text-slate-600 leading-relaxed">
                  {feature.description}
                </p>
              </div>
            );
          })}
        </div>

        {/* Additional Features */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {additionalFeatures.map((feature, index) => {
            const IconComponent = feature.icon;
            return (
              <div 
                key={index}
                className="group bg-white/60 backdrop-blur-sm p-6 rounded-xl border border-pink-100 hover:border-blue-200 transition-all duration-300 hover:shadow-lg"
              >
                <div className="flex items-center justify-center w-12 h-12 bg-slate-100 rounded-xl mb-4 group-hover:scale-110 transition-transform">
                  <IconComponent className="h-6 w-6 text-slate-600" />
                </div>
                <h4 className="text-lg font-semibold text-slate-800 mb-2">
                  {feature.title}
                </h4>
                <p className="text-slate-600 text-sm leading-relaxed">
                  {feature.description}
                </p>
              </div>
            );
          })}
        </div>

        {/* Stats Section */}
        <div className="mt-20 bg-white/80 backdrop-blur-sm rounded-3xl p-8 border border-pink-100">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8 text-center">
            <div className="group">
              <div className="text-3xl font-bold text-blue-500 mb-2 group-hover:scale-110 transition-transform">9+</div>
              <div className="text-slate-600">Years Experience</div>
            </div>
            <div className="group">
              <div className="text-3xl font-bold text-pink-500 mb-2 group-hover:scale-110 transition-transform">2</div>
              <div className="text-slate-600">Acres of Land</div>
            </div>
            <div className="group">
              <div className="text-3xl font-bold text-blue-500 mb-2 group-hover:scale-110 transition-transform">1-5</div>
              <div className="text-slate-600">Age Range</div>
            </div>
            <div className="group">
              <div className="text-3xl font-bold text-pink-500 mb-2 group-hover:scale-110 transition-transform">£10</div>
              <div className="text-slate-600">Per Hour</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Features;